var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5759_24650",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.828 6.00008L8.1613 10.6667L3.49463 6.00008"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1613 10.6667L7.17135 11.6567C7.71808 12.2034 8.60451 12.2034 9.15125 11.6567L8.1613 10.6667ZM11.838 5.01013L7.17135 9.6768L9.15125 11.6567L13.8179 6.99003L11.838 5.01013ZM9.15125 9.6768L4.48458 5.01013L2.50468 6.99003L7.17135 11.6567L9.15125 9.6768Z",
    fill: "#AEB1B8",
    mask: "url(#path-1-inside-1_5759_24650)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f5842d4f0e03a4c705ad423d080c3fb4.svg";
export { ForwardRef as ReactComponent };